.alert {
  flex-shrink: 0;
}
